import { render } from "./HowBusinessENG.vue?vue&type=template&id=11abdf0c&scoped=true"
import script from "./HowBusinessENG.vue?vue&type=script&lang=js"
export * from "./HowBusinessENG.vue?vue&type=script&lang=js"

import "./HowBusinessENG.vue?vue&type=style&index=0&id=11abdf0c&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11abdf0c"]])

export default __exports__